export default __webpack_public_path__ + "0d867969dbb44d2d33c0f8eff6d7959a.png";